/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './gallery-social-share.stache';
import urlUtil from 'scripts/utils/url';
import SocialShareService from 'scripts/services/social-share-service';


Component.extend({
    tag: 'gallery-social-share',
    template: template,
    viewModel: {
        hasHash: true,

        getVariables: function(){
            const url = urlUtil.getUrlFromPagePath(this.pagePath, this.hasHash);

            return {
                title: encodeURIComponent(this.title),
                text: this.title,
                image_url: this.image || '',
                rawDescription: this.description,
                description: encodeURIComponent(this.description),
                rawUrl: url,
                url: encodeURIComponent(url)
            };
        }
    },
    events: {

        '.js-facebook-share click': function() {
            SocialShareService.share('facebook', this.viewModel.getVariables());
        },

        '.js-twitter-share click': function() {
            SocialShareService.share('twitter', this.viewModel.getVariables());
        }

    }
});
